import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';
import { Toaster as ReactHotToaster } from 'react-hot-toast';

export const Toaster = ({ ...props }) => {
  const { desktop } = useBreakpoints();

  const professionalPortalTopPosition = desktop ? '3.75rem' : '3.2rem';

  return <ReactHotToaster containerStyle={{ top: professionalPortalTopPosition }} {...props} />;
};
